export default "__VITE_ASSET__jdgLGFEB__"